export default __webpack_public_path__ + "static/media/tx.83c5cd9a.png";